"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const react_smooth_collapse_1 = __importDefault(require("react-smooth-collapse"));
const emotion_1 = require("emotion");
const BlockButton_1 = __importDefault(require("./Utilities/BlockButton"));
const FlexBox_1 = __importDefault(require("./FlexBox"));
const Accordion = props => {
    const { actions, customOpen, defaultOpen, onClose, title, children, style, headerStyle, bodyStyle, className, onHeaderClick, variant } = props, rest = __rest(props, ["actions", "customOpen", "defaultOpen", "onClose", "title", "children", "style", "headerStyle", "bodyStyle", "className", "onHeaderClick", "variant"]);
    const initialOpen = customOpen || defaultOpen;
    const [open, setOpen] = react_1.useState(initialOpen);
    react_1.useEffect(() => {
        if (!open) {
            onClose && onClose();
        }
    }, [onClose, open]);
    const onLocalHeaderClick = event => {
        setOpen(prevOpen => {
            onHeaderClick(event, !prevOpen);
            return !prevOpen;
        });
    };
    const onActionContainerClick = event => {
        event.stopPropagation();
    };
    react_1.useEffect(() => {
        setOpen(customOpen || defaultOpen);
    }, [customOpen, defaultOpen]);
    return (react_1.default.createElement("div", Object.assign({ className: emotion_1.cx('accordion', className, { 'accordion-open': open, 'accordion-ghost': variant === 'ghost', 'accordion-minimal': variant === 'minimal' }), style: style }, rest),
        react_1.default.createElement(BlockButton_1.default, { className: "accordion-header", onClick: onLocalHeaderClick, style: headerStyle },
            react_1.default.createElement(FlexBox_1.default, { middle: true, spaceBetween: true },
                react_1.default.createElement(FlexBox_1.default, { middle: true, grow: 1 },
                    react_1.default.createElement("div", { className: "accordion-arrow" },
                        react_1.default.createElement("i", { className: emotion_1.cx('fa', 'fa-lg', { 'fa-angle-down': open, 'fa-angle-right': !open }) })),
                    title),
                actions && (react_1.default.createElement(BlockButton_1.default, { onClick: onActionContainerClick }, actions)))),
        react_1.default.createElement(react_smooth_collapse_1.default, { expanded: open },
            react_1.default.createElement("div", { className: "accordion-body", style: bodyStyle }, children))));
};
Accordion.propTypes = {
    actions: prop_types_1.default.node,
    children: prop_types_1.default.node,
    title: prop_types_1.default.node,
    defaultOpen: prop_types_1.default.bool,
    customOpen: prop_types_1.default.bool,
    style: react_style_proptype_1.default,
    headerStyle: react_style_proptype_1.default,
    bodyStyle: react_style_proptype_1.default,
    className: prop_types_1.default.string,
    onHeaderClick: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    variant: prop_types_1.default.oneOf(['default', 'ghost', 'minimal']),
};
Accordion.defaultProps = {
    defaultOpen: false,
    onHeaderClick: () => undefined,
    style: {},
    headerStyle: {},
    bodyStyle: {},
    className: '',
    variant: 'default',
};
exports.default = Accordion;
